import React from 'react'
import { Div, Button, } from "@components/Generics.react";
export default function MemberAnalytics() {
  return (
      <Div>
          This is the modal
   </Div>
  )
}
